/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
export const MIN_SEARCH_LENGTH = 3;
export const MEDIA_TYPE_SEASON = "SEASON";
export const PAGE_SIZE = 12;
